<template>
  <div>
    <!-- 期刊 -->
    <el-form-item
      label="期刊名称"
      prop="json.level_user_name"
    >
      <el-input
        style="width:400px"
        type="text"
        v-model="ruleForm.json.level_user_name"
        autocomplete="off"
        placeholder="请输入期刊名称"
      ></el-input>
    </el-form-item>
    <el-form-item
      label="期刊级别"
      prop="json.level"
    >
      <el-select
        v-model="ruleForm.json.level"
        placeholder="请选择期刊级别"
        style="width: 350px"
      >
        <el-option
          v-for="item in options"
          :key="item.id"
          :label="item.name"
          :value="item.name"
        >
        </el-option>
      </el-select>
    </el-form-item>
  </div>
</template>

<script>
export default {
  name: 'magazine',
  props: ['ruleForm'],
  data () {
    return {
      options: [],
    }
  },
  created () {
    this.getCateList()
  },
  methods: {
    //获取分类 
    async getCateList () {
      const { data: data } = await this.$http.post("cate/list", { type: 3 })
      this.options = data.data
    },
  }
}

</script>
<style lang="less" scoped>
</style>